// extracted by mini-css-extract-plugin
export default {"root":"BInCi5WH","input":"n4vyfezq","skeleton":"JgHbBNjp","flag":"_AaszmeK"};